export const soundsList = [
  { title: '5 Euro?', dataKey: 49 },
  { title: 'Village People 360 kick', dataKey: 50 },
  { title: 'Allemaal onvoldoende', dataKey: 51 },
  { title: 'Bam Bam Bam', dataKey: 52 },
  { title: 'Bel de wouten', dataKey: 53 },
  { title: '030 beter als 020', dataKey: 54 },
  { title: 'Biem!', dataKey: 55 },
  { title: 'Boer', dataKey: 56 },
  { title: 'Boodschap!', dataKey: 57 },
  { title: 'Cumshot', dataKey: 48 },
  { title: 'Das mien merk', dataKey: 58 },
  { title: 'Noem mij maar Willy', dataKey: 59 },
  { title: 'De hele klas heeft een onvoldoende', dataKey: 60 },
  { title: 'Dikke billen 5 reeten', dataKey: 61 },
  { title: 'Dikke BMW', dataKey: 62 },
  { title: 'Dis een jonko', dataKey: 63 },
  { title: 'Niet mijn winkel vriend', dataKey: 64 },
  { title: 'Helemaal knettah', dataKey: 65 },
  { title: 'Dumpert Anthem', dataKey: 66 },
  { title: 'DumpertReeten', dataKey: 67 },
  { title: 'Fuck', dataKey: 68 },
  { title: 'Hij heet geen Henk', dataKey: 69 },
  { title: 'Gefeliciteerd eh!', dataKey: 70 },
  { title: 'Geit', dataKey: 71 },
  { title: 'Godmiljaar', dataKey: 72 },
  { title: 'Kersemus', dataKey: 73 },
  { title: 'Rookmevrouw', dataKey: 74 },
  { title: 'Wat een grote vis', dataKey: 75 },
  { title: 'Handtekening!', dataKey: 76 },
  { title: 'Haha bier!', dataKey: 77 },
  { title: 'Hardcore will never die', dataKey: 78 },
  { title: 'Hekkie?', dataKey: 79 },
  { title: 'Hey!', dataKey: 80 },
  { title: 'Waaaaah', dataKey: 81 },
  { title: 'Ik hoef niet te tanken schat', dataKey: 82 },
  { title: 'Ik kon er niks aan doen', dataKey: 83 },
  { title: 'Ik neuk jullie allemaal de moeder', dataKey: 84 },
  { title: 'Ik wil gewoon tuteren', dataKey: 85 },
  { title: 'Ik wil kaas', dataKey: 86 },
  { title: 'Blikje in de water', dataKey: 87 },
  { title: 'Je halve kont staat open', dataKey: 88 },
  { title: 'Jeroen doe normaal gek', dataKey: 89 },
  { title: 'Ohohohoh WTF Jeroen', dataKey: 90 },
  { title: 'John Deere trekker', dataKey: 91 },
  { title: 'Kom op dan!', dataKey: 92 },
  { title: 'Koop dan!', dataKey: 93 },
  { title: 'Korter!', dataKey: 94 },
  { title: 'Krakaka!', dataKey: 95 },
  { title: 'Lekker batsen', dataKey: 96 },
  { title: 'Mand!', dataKey: 97 },
  { title: 'Man man man', dataKey: 98 },
  { title: 'Wat een mooi ding!', dataKey: 99 },
  { title: 'Net pindakaas gegeten', dataKey: 100 },
  { title: 'Niemand liegt tegen mij', dataKey: 101 },
  { title: 'Niet toeteren!', dataKey: 102 },
  { title: 'What? No munnie?', dataKey: 103 },
  { title: 'Je hebt nooit geen geld', dataKey: 104 },
  { title: 'Of nee toch niet', dataKey: 105 },
  { title: 'Optyvuh gauw!', dataKey: 106 },
  { title: 'Jij trekt ze toch over de balie?', dataKey: 107 },
  { title: 'Papa ik heb iets heel ergs gedaan', dataKey: 108 },
  { title: 'Plausibel', dataKey: 109 },
  { title: 'Van die grote postzakken', dataKey: 110 },
  { title: 'Hey Amigo! Don\t touch me', dataKey: 111 },
  { title: 'Alleen maar rondjes', dataKey: 112 },
  { title: "Iedereen noem 'm Willy", dataKey: 113 },
  { title: 'Shows met de mannen', dataKey: 114 },
  { title: 'Jullie spelen met mijn prive!', dataKey: 115 },
  { title: 'Steeds maar weer', dataKey: 116 },
  { title: 'Tatatatatatatata', dataKey: 117 },
  { title: 'U wou niet luisteren', dataKey: 118 },
  { title: 'De verkeerde kaaaaant', dataKey: 119 },
  { title: 'Zonne grote vuurbal jonguh', dataKey: 120 },
  { title: 'Vuurwerkje', dataKey: 121 },
  { title: 'Wat heb je?', dataKey: 122 },
  { title: 'Yes yes yes girl!', dataKey: 123 },
  { title: 'Zo is natuur', dataKey: 124 },
  { title: 'Keiglad', dataKey: 125 },
  { title: 'Helemaal mooi!', dataKey: 126 },
  { title: 'Lazer op!', dataKey: 127 },
  { title: 'Kangoeroe', dataKey: 128 },
  { title: 'Nitraatje erbij?', dataKey: 129 },
  { title: 'Strontbroek', dataKey: 130 },
  { title: 'Tongparty', dataKey: 131 },
  { title: 'Helemaal zand', dataKey: 132 },
  { title: 'Pardon? Doe normaal!', dataKey: 133 },
];
